module.exports = __webpack_public_path__ + "static/logo-portofaz-97fec34b4e085bc362f45bd502bec0c5.svg";